var map = {
	"./fish1.png": "Ynjx",
	"./fish10.png": "pMMU",
	"./fish11.png": "LXcA",
	"./fish12.png": "S/2t",
	"./fish13.png": "K/Fg",
	"./fish14.png": "hBoj",
	"./fish15.png": "JSAn",
	"./fish16.png": "rN3m",
	"./fish17.png": "S+5z",
	"./fish18.png": "zLM1",
	"./fish19.png": "GMkL",
	"./fish2.png": "7Z8D",
	"./fish26.png": "UCld",
	"./fish27.png": "ssea",
	"./fish28.png": "MaSD",
	"./fish29.png": "gfM8",
	"./fish3.png": "1Wg8",
	"./fish30.png": "Rqwc",
	"./fish31.png": "7CUd",
	"./fish32.png": "UmEy",
	"./fish33.png": "9LQ1",
	"./fish34.png": "miA+",
	"./fish35.png": "A/sL",
	"./fish36.png": "1Ysb",
	"./fish37.png": "FMtk",
	"./fish38.png": "onyl",
	"./fish39.png": "h8mY",
	"./fish4.png": "kuQQ",
	"./fish40.png": "iWR5",
	"./fish41.png": "g2xT",
	"./fish42.png": "VLgk",
	"./fish43.png": "XGAz",
	"./fish46.png": "7dJ7",
	"./fish47.png": "1H7R",
	"./fish48.png": "v6El",
	"./fish49.png": "Driq",
	"./fish5.png": "mPjJ",
	"./fish50.png": "jIuT",
	"./fish51.png": "dAAQ",
	"./fish52.png": "dUIQ",
	"./fish6.png": "SBa8",
	"./fish7.png": "VBCK",
	"./fish8.png": "Di+R",
	"./fish9.png": "ZSJM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77g5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish ^\.\/fish.*\.png$
// module id = 77g5
// module chunks = 0